module.exports = __webpack_public_path__ + "static/media/Steppr loyalty and gifting - Pitod.ad5e2031.webp";